import * as React from 'react';
import {
  useRecordContext,
  useInput,
  BooleanInput,
  InputProps,
} from 'react-admin';

interface DependentBooleanInputProps extends InputProps {
  dependsOnSource: string;
}

const DependentBooleanInput: React.FC<DependentBooleanInputProps> = ({
  dependsOnSource,
  ...restProps
}) => {
  const record = useRecordContext();
  const isEnabled = record?.purchase_order !== dependsOnSource;

  const {
    input: { value, onChange },
  } = useInput(restProps);

  React.useEffect(() => {
    if (value === undefined) {
      onChange(isEnabled);
    }
  }, [isEnabled, value, onChange]);

  return <BooleanInput {...restProps} disabled={!isEnabled} />;
};

export default DependentBooleanInput;
